import React from "react";
import { useSelector } from "react-redux";
import { isMobile } from "utils/device-detect";
import ReactivateSubscription from "components/reactivate-subscription";
import { useGlobalContext } from "context/global";
import clsx from "clsx/lite";

const ReactivationBanner = () => {
	const { translation, isSubscriptionPage, isCollection } = useGlobalContext();
	const { subscriptionId, isActive, status } = useSelector(state => state.account.subscription);

	const formattedStatus = translation.subscription?.status[status.toLowerCase()]?.toLowerCase();
	const statusMessage = isMobile() ?
		translation.subscription.reactivation_banner_message_mobile : translation.subscription.reactivation_banner_message;
	const message = statusMessage?.replace("{status}", formattedStatus);

	if (!subscriptionId || isActive) return null;

	return (
		<div className={clsx(
			"bottom-fixed-banner lg:!bottom-auto lg:top-18 !bg-yellow-green",
			// If it's a subscription page and a collection (basically that is manage-products page),
			// we need to adjust the bottom spacing because of the sticky cart
			(isSubscriptionPage && isCollection) && "!bottom-20"
		)}>
			<div className="hidden md:block" />
			<span className="md:max-w-[50%] text-center md:text-left">{message}</span>
			<ReactivateSubscription className="!btn-orange py-3 !w-56" />
		</div>
	);
};

export default ReactivationBanner;